import { Box, Button, Dialog, DialogActions, DialogTitle, Typography } from '@mui/material';

import { LIST } from './tokens';

export type LeftOutRow = { id: string; student: string; teacher: string; class: string; grade: string };

const cell = { fontFamily: LIST.font, fontSize: 16, lineHeight: '24px', color: LIST.ink, textAlign: 'left', height: 40, px: '8px', borderBottom: `1px solid ${LIST.divider}`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } as const;

export function LeftOutDialog({ open, rows, showTeacher, onClose }: { open: boolean; rows: LeftOutRow[]; showTeacher: boolean; onClose: () => void }) {
  const heading = `${rows.length} ${rows.length === 1 ? 'student' : 'students'} left out`;
  return (
    <Dialog open={open} onClose={onClose} className="report-dialog" aria-labelledby="left-out-title" PaperProps={{ sx: { borderRadius: '12px', width: 640, maxWidth: '100%', m: 2 } }}>
      <DialogTitle id="left-out-title" sx={{ fontFamily: LIST.font, fontSize: 20, lineHeight: '28px', fontWeight: 700, color: LIST.ink, p: '24px 24px 4px' }}>
        {heading}
      </DialogTitle>
      <Typography sx={{ px: '24px', pb: '16px', fontFamily: LIST.font, fontSize: 16, lineHeight: '24px', color: LIST.muted }}>
        Nothing on file for the chosen sections
      </Typography>
      <Box sx={{ maxHeight: 500, overflowY: 'auto', px: '16px' }}>
        <Box component="table" sx={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
          <Box component="thead" sx={{ position: 'sticky', top: 0, bgcolor: '#FFFFFF' }}>
            <tr>
              <Box component="th" scope="col" sx={{ ...cell, fontWeight: 700, borderTop: `1px solid ${LIST.divider}` }}>Student</Box>
              {showTeacher && <Box component="th" scope="col" sx={{ ...cell, fontWeight: 700, width: 136, borderTop: `1px solid ${LIST.divider}` }}>Teacher</Box>}
              <Box component="th" scope="col" sx={{ ...cell, fontWeight: 700, width: showTeacher ? 176 : 200, borderTop: `1px solid ${LIST.divider}` }}>Class</Box>
              <Box component="th" scope="col" sx={{ ...cell, fontWeight: 700, width: showTeacher ? 64 : 80, borderTop: `1px solid ${LIST.divider}` }}>Grade</Box>
            </tr>
          </Box>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <Box component="td" sx={cell}>{row.student}</Box>
                {showTeacher && <Box component="td" sx={cell}>{row.teacher}</Box>}
                <Box component="td" sx={cell}>{row.class}</Box>
                <Box component="td" sx={cell}>{row.grade}</Box>
              </tr>
            ))}
          </tbody>
        </Box>
      </Box>
      <DialogActions sx={{ p: '16px 24px 24px', borderTop: `1px solid ${LIST.divider}`, mt: '8px' }}>
        <Button onClick={onClose} sx={{ textTransform: 'none', fontFamily: LIST.font, fontWeight: 600, fontSize: 16, color: LIST.primary }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
